import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import classNames from 'classnames';
import IconArrowDownSimple from 'components/icons/iconArrowDownSimple';
import { colorGrayLight5 } from 'styles/layout/colors';
const baseCustomStyles = {
  container: provided => ({
    ...provided,
    width: '100%',
    padding: '.5rem',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '4px',
    borderColor: colorGrayLight5,
    cursor: 'pointer',
    position: 'relative'
  }),
  control: () => ({
    border: 0,
    display: 'flex',
    color: '#333',
    width: '100%',
    justifyContent: 'space-between'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  singleValue: provided => ({
    ...provided,
    color: '#333'
  }),
  valueContainer: () => ({
    display: 'flex',
    padding: '0.125rem 0.5rem'
  })
};
const DropdownIndicator = props => {
  const $ = _c(7);
  const {
    selectProps: t0
  } = props;
  const {
    menuIsOpen
  } = t0;
  let t1;
  if ($[0] !== menuIsOpen) {
    t1 = classNames({
      "rotate-180": menuIsOpen
    });
    $[0] = menuIsOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <IconArrowDownSimple data-testid="select-dropdown-button" className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== t2) {
    t3 = <components.DropdownIndicator {...props}>{t2}</components.DropdownIndicator>;
    $[4] = props;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
DropdownIndicator.propTypes = {
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool.isRequired
  }).isRequired
};
const BaseSelectField = t0 => {
  const $ = _c(29);
  const {
    placeholder,
    onChange,
    options,
    isDisabled: t1,
    searchable: t2,
    classNamePrefix: t3,
    customStyles: t4,
    defaultValue: t5,
    getOptionLabel: t6,
    customComponents: t7,
    getOptionValue: t8,
    className: t9,
    ariaLabel: t10,
    value: t11
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  const searchable = t2 === undefined ? false : t2;
  const classNamePrefix = t3 === undefined ? "" : t3;
  let t12;
  if ($[0] !== t4) {
    t12 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t12;
  } else {
    t12 = $[1];
  }
  const customStyles = t12;
  let t13;
  if ($[2] !== t5) {
    t13 = t5 === undefined ? {} : t5;
    $[2] = t5;
    $[3] = t13;
  } else {
    t13 = $[3];
  }
  const defaultValue = t13;
  const getOptionLabel = t6 === undefined ? null : t6;
  let t14;
  if ($[4] !== t7) {
    t14 = t7 === undefined ? {} : t7;
    $[4] = t7;
    $[5] = t14;
  } else {
    t14 = $[5];
  }
  const customComponents = t14;
  const getOptionValue = t8 === undefined ? null : t8;
  const className = t9 === undefined ? "" : t9;
  const ariaLabel = t10 === undefined ? "" : t10;
  let t15;
  if ($[6] !== t11) {
    t15 = t11 === undefined ? {} : t11;
    $[6] = t11;
    $[7] = t15;
  } else {
    t15 = $[7];
  }
  const value = t15;
  let conditionalProps;
  if ($[8] !== getOptionLabel || $[9] !== getOptionValue || $[10] !== value) {
    conditionalProps = {};
    if (getOptionLabel) {
      conditionalProps.getOptionLabel = getOptionLabel;
    }
    if (getOptionValue) {
      conditionalProps.getOptionValue = getOptionValue;
    }
    if (!isEmpty(value)) {
      conditionalProps.value = value;
    }
    $[8] = getOptionLabel;
    $[9] = getOptionValue;
    $[10] = value;
    $[11] = conditionalProps;
  } else {
    conditionalProps = $[11];
  }
  const t16 = `react-select-container w-full ${className}`;
  const t17 = classNamePrefix || "react-select";
  let t18;
  if ($[12] !== customStyles) {
    t18 = {
      ...baseCustomStyles,
      ...customStyles
    };
    $[12] = customStyles;
    $[13] = t18;
  } else {
    t18 = $[13];
  }
  let t19;
  if ($[14] !== customComponents) {
    t19 = {
      DropdownIndicator,
      ...customComponents
    };
    $[14] = customComponents;
    $[15] = t19;
  } else {
    t19 = $[15];
  }
  let t20;
  if ($[16] !== ariaLabel || $[17] !== conditionalProps || $[18] !== defaultValue || $[19] !== isDisabled || $[20] !== onChange || $[21] !== options || $[22] !== placeholder || $[23] !== searchable || $[24] !== t16 || $[25] !== t17 || $[26] !== t18 || $[27] !== t19) {
    t20 = <Select className={t16} classNamePrefix={t17} placeholder={placeholder} onChange={onChange} options={options} isDisabled={isDisabled} isSearchable={searchable} defaultValue={defaultValue} aria-label={ariaLabel} controlShouldRenderValue={true} styles={t18} components={t19} {...conditionalProps} />;
    $[16] = ariaLabel;
    $[17] = conditionalProps;
    $[18] = defaultValue;
    $[19] = isDisabled;
    $[20] = onChange;
    $[21] = options;
    $[22] = placeholder;
    $[23] = searchable;
    $[24] = t16;
    $[25] = t17;
    $[26] = t18;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  return t20;
};
BaseSelectField.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  classNamePrefix: PropTypes.string,
  customComponents: PropTypes.object,
  customStyles: PropTypes.object,
  defaultValue: PropTypes.object,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
  value: PropTypes.object
};
export default BaseSelectField;